import React, { useState } from "react";
import { Modal } from "../../../../../../../shared/Modal/Modal";
import { PasswordVisibilityToggle } from "../../shared/PasswordVisibilityToggle";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { CircularProgress } from "../../../../../../../shared/CircularProgress/CircularProgress";
import { Button } from "../../../../../../../shared/Button/Button";
import { Input } from "../../../../../../../shared/Input/Input";
import { not } from "../../../../../../../utilities/fp";

export function ModalConfirm({ onClose, onSubmit, isSubmitting }) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");

  const submit = () => {
    if (!password?.trim()) {
      return uiNotification.error("Password is required");
    }
    onSubmit(password);
  };

  return (
    <Modal
      isOpen
      headerNoBorder
      footerNoBorder
      shouldCloseOnOverlayClick={false}
      size="small"
      onClose={onClose}
      header={<Modal.Title>Confirm Password</Modal.Title>}
      footer={
        <Button
          onClick={submit}
          isDisabled={isSubmitting || !password?.trim()}
          leftAdornment={
            isSubmitting ? (
              <CircularProgress size="small" color="white" />
            ) : undefined
          }
        >
          Update answer
        </Button>
      }
    >
      <Input
        type={isPasswordVisible ? "text" : "password"}
        placeholder="Enter your password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        rightAdornment={
          <PasswordVisibilityToggle
            isVisible={isPasswordVisible}
            onToggle={() => setIsPasswordVisible(not)}
          />
        }
      />
    </Modal>
  );
}
